import { useMemo } from 'react'
import { Select } from '@workwhile/ui'
import { track } from 'lib/amplitude'
import { useVndlyTimesheetContext } from '../context/VndlyTimesheetProvider'

export const CompaniesSelector = () => {
  const {
    state: { filters, companies },
    actions: { setFilters },
  } = useVndlyTimesheetContext()

  const selectedCompanies = useMemo(() => {
    const selectedIdsSet = new Set(filters.companyIds)
    return companies.filter((c) => selectedIdsSet.has(c.value))
  }, [companies, filters.companyIds])

  return (
    <Select
      options={companies}
      isMulti
      value={selectedCompanies}
      placeholder={
        selectedCompanies.length > 0
          ? `${selectedCompanies.length} selected companies`
          : 'Filter by Company'
      }
      isClearable={true}
      onChange={(newValue) => {
        track('button_click, vndly_timesheet_filter_company', {
          companyIds: newValue?.map((v) => v.value) ?? [],
        })
        setFilters({
          ...filters,
          companyIds: newValue?.map((v) => v.value) ?? [],
        })
      }}
      closeMenuOnSelect={false}
      hideSelectedOptions={false}
      controlShouldRenderValue={false}
    />
  )
}
